/**
 * Read chart-related CSS custom properties from the current theme.
 * Returns default (light-theme) values when running outside a browser
 * or when the root element is not yet available.
 */

function getCSSVar(name, fallback) {
    try {
        // Read from documentElement (<html> where data-theme is set)
        const val = getComputedStyle(document.documentElement).getPropertyValue(name).trim();
        if (val) return val;
    } catch { /* ignore */ }
    try {
        const bodyStyles = getComputedStyle(document.body);
        const val = bodyStyles.getPropertyValue(name).trim();
        if (val) return val;
    } catch { /* ignore */ }
    return fallback;
}

export function getThemeColors() {
    return {
        gridColor:       getCSSVar('--chart-grid-color',       'rgba(0, 0, 0, 0.1)'),
        textColor:       getCSSVar('--chart-text-color',       '#495057'),
        datalabelColor:  getCSSVar('--chart-datalabel-color',  '#212529'),
        bgColor:         getCSSVar('--bg-body',                '#f4f6f9'),
    };
}
